var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoverUploadDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#E42125"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50016 15.6666C7.17933 15.6666 6.90458 15.5523 6.67591 15.3236C6.44725 15.0949 6.33311 14.8204 6.3335 14.4999V12.7499H7.50016V14.4999H14.5002V12.7499H15.6668V14.4999C15.6668 14.8208 15.5525 15.0955 15.3238 15.3242C15.0952 15.5528 14.8206 15.667 14.5002 15.6666H7.50016ZM10.4168 13.3333V8.57909L8.90016 10.0958L8.0835 9.24992L11.0002 6.33325L13.9168 9.24992L13.1002 10.0958L11.5835 8.57909V13.3333H10.4168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverUploadDoc);
export default __webpack_public_path__ + "static/media/hoverUploadDoc.9f124c19c465f1415c6942bbc1072af3.svg";
export { ForwardRef as ReactComponent };